import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AnalyticsService} from '../../shared/analytics.service';
import {AuthService} from '../../shared/auth.service';
import {ModalComponent} from '../../shared/modal/modal.component';
import {NavigationService} from '../../shared/navigation.service';
import {ClientApiService} from '../client-api.service';

@Component({
  selector: 'terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsModalComponent {

  @Input() page: string;

  @Output() complete = new EventEmitter<void>();

  @ViewChild('termsModal') termsModal: ModalComponent;
  @ViewChild('signSuccessModal') signSuccessModal: ModalComponent;

  timecard: TimecardDetails;
  timecardIds: number[];
  termsLoading$ = new BehaviorSubject(false);
  masquerading$ = this.Auth.masquerading$;

  constructor(private Api: ClientApiService,
              private Auth: AuthService,
              private Analytics: AnalyticsService,
              private Navigation: NavigationService) {
  }

  show(timecardIds: number[]) {
    this.timecardIds = timecardIds;
    this.timecard = null;
    this.termsLoading$.next(false);
    this.termsModal.show();
  }

  showForSingleTimecard(timecard: TimecardDetails) {
    this.timecardIds = [];
    this.timecard = timecard;
    this.termsLoading$.next(false);
    this.termsModal.show();
  }

  okClicked() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.Analytics.trackEvent(`${this.page}: Terms modal OK clicked`);
    this.termsLoading$.next(true);

    if (this.timecard) {
      this.signSingleTimecard();
    } else {
      this.signTimecards();
    }
  }

  cancelClicked() {
    this.Analytics.trackEvent(`${this.page}: Terms modal Cancel clicked`);
    this.termsModal.hide();
  }

  signSingleTimecard() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.Analytics.trackEvent(`${this.page}: Timecard(s) signed - single`, {count: 1});

    this.Api.signSingleTimecard(this.timecard)
      .subscribe(() => this.showSuccess(),
        err => this.handleError(err, 'Failed to sign timecard'));
  }

  signTimecards() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.Analytics.trackEvent(`${this.page}: Timecard(s) signed`, {count: this.timecardIds.length});

    this.Api.signTimecards(this.timecardIds).subscribe(() => {
      this.showSuccess();
    }, err => {
      this.handleError(err, 'Failed to sign timecards');
    });
  }

  showSuccess() {
    if (this.masquerading$.getValue()) {
      return;
    }
    setTimeout(() => {
      this.signSuccessModal.hide();
    }, 3000);

    this.signSuccessModal.show();
    this.termsModal.hide();
    this.complete.emit();
  }

  handleError(err, message) {
    console.error(message, err);
    if (err.status === 401) {
      return this.Navigation.handleLogin();
    } else {
      return this.Navigation.handleError(err);
    }
  }

}
